import React, {useState,useReducer,useEffect} from 'react'
import Swal from "sweetalert2";
import axios from 'axios';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form';
 import Contex from "./CreateContext"
const ContextAPI = (props) => {
            //  react state
const [ExperienceData, setExperienceData] = useState([])
const [SkillData, setSkillData] = useState([])
const [ResearchItemData, setResearchItemData] = useState([])
const [EduData, setEduData] = useState([])
const [VerifedToken, setVerifedToken] = useState('')

//  modal state
 const [show, setShow] = useState(false); 
//  alert state
const [Alert, setAlert] = useState(null);
//  update research items state
const [ResearchItemEditData, setResearchItemEditData] = useState({id : "",etitle : "", edesc:"",authors:"",eurl:"", date:"", category:""})

const showAlert = (type,message)=>{
setAlert({
  msg:message,
  typ:type
})
setTimeout(() => {
  setAlert(null)
}, 5000);
}
 
const   token  = localStorage.getItem("at")

 

// 💖 get gata
                //   get Experience
 const fetchExperienceData = async() => {
        let res = await fetch('https://long-red-goshawk-fez.cyclic.app/api/data/getExperience', { method:"POST"})
      if(!res.ok){
     
    }
    let resjson = await res.json()
   
    // let dataa = resjson.data
    //
    
    setExperienceData(resjson)
    
    
  }    
  //    get ResearchItemData
  const fetchResearchItemData = async() => {
    let res = await fetch('https://long-red-goshawk-fez.cyclic.app/api/data/getResearchItem', { method:"POST", headers :{
      'Content-Type': 'application/json'
    }, 
   
  })
    if(!res.ok){
     
      // alert("err")
      }
      let resjson = await res.json()
     
      // let dataa = resjson.data
      //

      setResearchItemData(resjson)

                }
  const  fetchSkillData = async() => {
    let res = await fetch('https://long-red-goshawk-fez.cyclic.app/api/data/getSkill', { method:"POST", headers :{
      'Content-Type': 'application/json'
    }})
    if(!res.ok){
     
      // alert("err")
      }
      let resjson = await res.json()
     
      
      setSkillData(resjson)

                }
  const  fetchEdu = async() => {
    let res = await fetch('https://long-red-goshawk-fez.cyclic.app/api/data/getEdu', { method:"POST", headers :{
      'Content-Type': 'application/json'
    }})
    if(!res.ok){
     
      // alert("err")
      }
      let resjson = await res.json()
     
      
      setEduData(resjson)

                }
// const getCv = async () =>{
//   // let res = await fetch("", {method: 'POST',
//   // headers: {
//   //   'Content-Type': 'application/pdf',
//   // }})
//   const url = "https://8000-kishore1477-hirabb-b2c5p2j47is.ws-eu73.gitpod.io/api/data/getCv"
//   const resAx =  axios.post(url, {method:"POST",responseType:"blob"})
 
//   //
//  return  resAx
// }

// 😜 Create data
  const handleAddResearchItem = async( title, desc, catg, url , date, authors) => {

     const data = {
            
            title: title,
            pub_date:date ,
            authors:authors,
            url: url,
            desc:desc, 
            category:catg

        }
       
        const res = await fetch('https://long-red-goshawk-fez.cyclic.app/api/data/createResearchItem', {
            method: 'POST', headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
   
        return res 

      
  }

  const CreateExperience = async(job, dept,  date, institute)=>{
    const data = {
            
      job:job,
      department:dept,
      institute:institute,
      date:date

  }
 
  const url = "https://long-red-goshawk-fez.cyclic.app/api/data/createExperience"
  const res = await fetch(url, {
      method: 'POST', headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
      },
     
      body: JSON.stringify(data)
  })

  return res 
  }
  const CreateSkill = async(name, desc)=>{
    const skillData = {
            
     name:name,
     desc:desc

  }
 
  const url = "https://long-red-goshawk-fez.cyclic.app/api/data/createSkill"
  const res = await fetch(url, {
      method: 'POST', headers: {
        'Authorization': token,

          'Content-Type': 'application/json'
      },
     
      body: JSON.stringify(skillData)
  })

  return res 
  }
  const  sentContactData = async( fullName, email, phone, msg)=>{
    const contactData = {
            
      fullName,
       email, 
       phone, 
       msg

  }
  
 
  const url = "https://long-red-goshawk-fez.cyclic.app/api/data/sentContactData"
  const res = await fetch(url, {
      method: 'POST', headers: {

          
          'Content-Type': 'application/json'
      },
     
      body: JSON.stringify(contactData)
  })
  


  }

  const CreateEdu = async( degree, uni, dept, date)=>{
    const EduData = {
            
     degree:degree,
     uni:uni,
     dept:dept,
     date:date

  }
 
  const url = "https://long-red-goshawk-fez.cyclic.app/api/data/createEdu"
  const res = await fetch(url, {
      method: 'POST', headers: {
        'Authorization': token,

          'Content-Type': 'application/json'
      },
     
      body: JSON.stringify(EduData)
  })

  return res 
  } 
  


// 🔼 UPDATE data

     //  update research item
const handleEditResearchItem =(existingData)=>{
  handleShow()
  setResearchItemEditData({id :existingData.id, etitle:existingData.title,edesc:existingData.description,authors:existingData.authors,  eurl:existingData.url, date:existingData.pub_date, category:existingData.category})
}
        const EditResearchItem = async(id,title,desc, author,ulr, date, category)=>{
          const data ={
            title:title,
            desc:desc,
            authors: author,
            url:ulr,
            pub_date:date,
             category:category
          }
    let url =`https://long-red-goshawk-fez.cyclic.app/api/data/updateResearchItem/${id}`
   
     const rawResponse = await fetch(url, {
      method: 'PUT', headers: {
        'Authorization': token,
                'Content-Type': 'application/json'

            },
      body: JSON.stringify(data)
    });
    return  rawResponse
   
  
        }
const onChange =(e)=>{
  setResearchItemEditData({...ResearchItemEditData, [e.target.name] : e.target.value})
  
      }
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
const handleUpdateClick = async()=>{
 const {id, etitle,edesc,authors, eurl, date , category}= ResearchItemEditData
 const res =  await  EditResearchItem(id, etitle,edesc,authors, eurl, date , category  )
 const json = await  res.json()

  handleClose()
  if (!res.ok) {
     showAlert("danger", json.msg)
    
  }else{
   await  fetchResearchItemData()
     showAlert("success",json.msg)
  }


}            
                    //     update Experince
const updateExperience = async(data)=>{
  const {id, job, institute, department, date} = data
  const Expdata ={
     job:job,
     date:date,
     institute:institute,
     department:department
  }
 
let url =`https://long-red-goshawk-fez.cyclic.app/api/data/updateExperience/${id}`

const res = await fetch(url, {
method: 'PUT', headers: {
  'Authorization': token,
        'Content-Type': 'application/json'
    },
body: JSON.stringify(Expdata)
});
return  res
} 
                    //  update Skill
const  updateSkill = async(data)=>{
  const {id, name, desc} = data
  const Skilldata ={
     name:name, 
     desc:desc
  }
 
let url =`https://long-red-goshawk-fez.cyclic.app/api/data/updateSkill/${id}`

const res = await fetch(url, {
method: 'PUT', headers: {
  'Authorization': token,
        'Content-Type': 'application/json'
    },
body: JSON.stringify(Skilldata)
});
return  res
}
                    //  update Education
const  updateEdu = async(data)=>{
  
  const {id, degree, dept,uni, date} = data
  const Edudata ={
    id, degree, dept,uni, date
  }
 
let url =`https://long-red-goshawk-fez.cyclic.app/api/data/updateEdu/${id}`

const res = await fetch(url, {
method: 'PUT', headers: {
  'Authorization': token,
        'Content-Type': 'application/json'
    },
body: JSON.stringify(Edudata)
});
return  res
}
 
// 😋 Delete data
                //    Delete Research item
  const deleteResearchItem = async({id})=>{
      const url = `https://long-red-goshawk-fez.cyclic.app/api/data/deleteResearchItem/${id}`
      const headers = {
          'Authorization': token,
      }
      let res = await fetch(url, { method :"DELETE" , headers})
    return  res
    }
   
      const handleDeleteResearchItem = async (id) => {
    const res = await Swal.fire({
      title: "Confirm",
      text: "Are you sure want to delete this note?",
      icon: "info",
      confirmButtonText: "Continue",
      showCancelButton: true,
    });
    if (res.isConfirmed) {
     const  res = await   deleteResearchItem(id)
  const json =  await res.json()
      if(!res.ok){
        showAlert("danger",json.msg)
      }else{
        await fetchResearchItemData()
      Swal.fire("Deleted!",  json.msg, "success");
        showAlert("success",json.msg)

      }
    } else {
      Swal.fire("Cancelled", "Your note is safe :)", "error");
    }
  };
                    //    Delete Experience 
const deleteExperience = async({id})=>{
                        const url = `https://long-red-goshawk-fez.cyclic.app/api/data/deleteExperience/${id}`
                        const headers = {
                          'Authorization': token
                        }
                        let res = await fetch(url, { method :"DELETE" , headers})
                      return  res
                      }
 const  handleDeleteExperience = async (id) => {
                      const res = await Swal.fire({
                        title: "Confirm",
                        text: "Are you sure want to delete this item?",
                        icon: "info",
                        confirmButtonText: "Continue",
                        showCancelButton: true,
                      });
                      if (res.isConfirmed) {
                       const  res = await    deleteExperience(id)
                    const json =  await res.json()
                   
                        if(!res.ok){
                          showAlert("danger",json.msg)
                        }else{
                          await fetchExperienceData()
                        Swal.fire("Deleted!",  json.msg, "success");
                          showAlert("success",json.msg)
                  
                        }
                      } else {
                        Swal.fire("Cancelled", "Your note is safe :)", "error");
                      }
                    };
                    //    Delete  Skill 
 const deleteSkill= async({id})=>{
                        const url = `https://long-red-goshawk-fez.cyclic.app/api/data/deleteSkill/${id}`
                        const headers = {
                         'Authorization': token
                        }
                        let res = await fetch(url, { method :"DELETE",headers })
                      return  res
                      }
                     
       const  handleDeleteSkill = async (id) => {
                      const res = await Swal.fire({
                        title: "Confirm",
                        text: "Are you sure want to delete this item?",
                        icon: "info",
                        confirmButtonText: "Continue",
                        showCancelButton: true,
                      });
                      if (res.isConfirmed) {
                       const  res = await     deleteSkill(id)
                    const json =  await res.json()
                        if(!res.ok){
                          showAlert("danger",json.msg)
                        }else{
                          await fetchSkillData()
                        Swal.fire("Deleted!",  json.msg, "success");
                          showAlert("success",json.msg)
                  
                        }
                      } else {
                        Swal.fire("Cancelled", "Your note is safe :)", "error");
                      }
     };
                    //    Delete  education 
 const deleteEdu= async({id})=>{
                        const url = `https://long-red-goshawk-fez.cyclic.app/api/data/deleteEdu/${id}`
                        const headers = {
                          'Authorization': token
                          
                        }
                        let res = await fetch(url, { method :"DELETE", headers })
                      return  res
                      }
                     
       const  handleDeleteEdu = async (id) => {
                      const res = await Swal.fire({
                        title: "Confirm",
                        text: "Are you sure want to delete this item?",
                        icon: "info",
                        confirmButtonText: "Continue",
                        showCancelButton: true,
                      });
                      if (res.isConfirmed) {
                       const  res = await     deleteEdu(id)
                    const json =  await res.json()
                        if(!res.ok){
                          showAlert("danger",json.msg)
                        }else{
                          await fetchEdu()
                        Swal.fire("Deleted!",  json.msg, "success");
                          showAlert("success",json.msg)
                  
                        }
                      } else {
                        Swal.fire("Cancelled", "Your note is safe :)", "error");
                      }
     };


  return (
    <div>
    <Button  hidden  variant="primary" onClick={handleShow}>
Launch static backdrop modal
</Button>
{/* modal  template */}
<Modal show={show} onHide={handleClose} backdrop="static"keyboard={false}>
<Modal.Header closeButton>
  <Modal.Title>Update   here!</Modal.Title>
</Modal.Header>
<Modal.Body>
<Form>
<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Title</Form.Label>
<Form.Control type="text" placeholder="title" name='etitle'onChange={onChange}  value ={ResearchItemEditData.etitle}   />

</Form.Group>

<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Description</Form.Label>
{ ResearchItemEditData.edesc && ResearchItemEditData.edesc.length ===0 ? <>

<Form.Control  as="textarea" placeholder="description" name='edesc' onChange={onChange} value ={ResearchItemEditData.edesc } />
</>:<>

<Form.Control as="textarea" rows={6}  placeholder="description" name='edesc' onChange={onChange} value ={ ResearchItemEditData.edesc && ResearchItemEditData.edesc.length > 100 ? ResearchItemEditData.edesc.substring(0, 323):ResearchItemEditData.edesc} />

</>}
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Authors</Form.Label>
<Form.Control type="text" placeholder="authors"  name ='authors'onChange={onChange} value ={ResearchItemEditData.authors} />
</Form.Group>
<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Url</Form.Label>
<Form.Control type="text" placeholder="url"  name ='eurl'onChange={onChange} value ={ResearchItemEditData.eurl} />
</Form.Group>
<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Published date</Form.Label>
<Form.Control type="text" placeholder=""  name ='date'onChange={onChange} value ={ResearchItemEditData.date} />
</Form.Group>


</Form>
</Modal.Body>
<Modal.Footer>
  <Button variant="secondary" onClick={handleClose}>
    Close
  </Button>
  <Button variant="primary" onClick={handleUpdateClick} >Update  </Button>
   
</Modal.Footer>
</Modal>

    <Contex.Provider value ={{ExperienceData, handleEditResearchItem,fetchExperienceData,ResearchItemData, fetchResearchItemData, handleDeleteResearchItem, Alert, handleAddResearchItem, showAlert, CreateExperience,  updateExperience, handleDeleteExperience, CreateSkill, fetchSkillData, SkillData, updateSkill, handleDeleteSkill, sentContactData, EduData, fetchEdu, CreateEdu, updateEdu, handleDeleteEdu}}>
     {props.children}
    </Contex.Provider>
    
    </div>
  )
}

export default ContextAPI